import { gql } from "@apollo/client";

export const GET_ALL_ORDERS = gql`
  query myOrders($pagination: PaginationInput) {
    myOrders(pagination: $pagination) {
      pagination {
        page
        limit
        total
      }
      orders {
        _id
        price
        quantity
        grossTotal
        color
        infill
        material
        design {
          description
          featuredImage
          name
          images
          design
        }
        designId
        platformOrderNo
        status
        printer {
          name
          length
          height
          width
        }
        printerId
        requestedByUserId
        requestedForUserId
        requestedByUser {
          _id
          firstName
          lastName
          role
        }
        requestedForUser {
          _id
          firstName
          lastName
          role
        }
        shippingId
        shippingPrice
        shippingDetail {
          deliveryLocation
          deliveryAddress
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_ALL_ORDERS_FOR_ADMIN = gql`
  query allOrders(
    $pagination: PaginationInput
    $filter: FilterOrderInput
    $sort: SortOrderInput
  ) {
    allOrders(pagination: $pagination, filter: $filter, sort: $sort) {
      pagination {
        page
        limit
        total
      }
      orders {
        _id
        price
        grossTotal
        quantity
        color
        infill
        material
        design {
          _id
          name
        }
        designId
        platformOrderNo
        status
        printer {
          _id
          name
        }
        printerId
        requestedByUserId
        requestedForUserId
        requestedByUser {
          _id
          firstName
          lastName
        }
        requestedForUser {
          _id
          firstName
          lastName
        }
        applicationFee
        printingPrice
        designPrice
        shippingId
        createdAt
        updatedAt
      }
    }
  }
`;

export const MY_ORDERS_V2 = gql`
  query myOrdersV2($pagination: PaginationInput) {
    myOrdersV2(pagination: $pagination) {
      pagination {
        page
        limit
        total
      }
      orders {
        _id
        platformOrderNo
        requestedByUserId
        requestedByUser {
          _id
          firstName
          lastName
          role
        }
        subTotal
        grossTotal
        packages {
          _id
          requestedForUserId
          requestedForUser {
            _id
            firstName
            lastName
            role
          }
          orderType
          deliveryType
          items {
            quantity
            scale
            color
            infill
            material
            printingPrice
            designPrice
            design {
              description
              featuredImage
              name
              images
              design
            }
            designId
            status
            printer {
              _id
              name
              length
              height
              width
              postalAddress
              postalStreet
              postalCity
              postalState
              country
            }
            printerId
          }
          shippingDetail {
            from
            fromLocation
            fromAddress
            fromState
            countryCode
          }
          shippingPrice
          shippingId
          grossSellerTotal
        }
        shippingDetail {
          to
          overseas
          postServiceCode
          countryCode
          deliveryLocation
          deliveryAddress
          deliveryState
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_ALL_ORDERS_FOR_ADMIN_V2 = gql`
  query allOrdersV2(
    $pagination: PaginationInput
    $filter: FilterOrderInput
    $sort: SortOrderInput
  ) {
    allOrdersV2(pagination: $pagination, filter: $filter, sort: $sort) {
      pagination {
        page
        limit
        total
      }
      orders {
        _id
        platformOrderNo
        requestedByUserId
        requestedByUser {
          _id
          firstName
          lastName
          role
        }
        subTotal
        grossTotal
        packages {
          _id
          requestedForUserId
          requestedForUser {
            _id
            firstName
            lastName
            role
          }
          orderType
          deliveryType
          items {
            quantity
            scale
            color
            infill
            material
            printingPrice
            designPrice
            design {
              description
              featuredImage
              name
              images
              design
            }
            designId
            status
            printer {
              _id
              name
              length
              height
              width
              postalAddress
              postalStreet
              postalCity
              postalState
              country
            }
            printerId
          }
          shippingDetail {
            from
            fromLocation
            fromAddress
            fromState
            countryCode
          }
          shippingPrice
          shippingId
          grossSellerTotal
        }
        shippingDetail {
          to
          overseas
          postServiceCode
          countryCode
          deliveryLocation
          deliveryAddress
          deliveryState
        }
        createdAt
        updatedAt
      }
    }
  }
`;

